import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useAuth } from '../../../contexts/AuthContext';
import { createClient, createEmptyClient } from '../../../services/clientsService';
import type { Client } from '../../../types/client';
import { clientCrmEn } from '../../../content/clientCrm.en';
import { clientsEn } from '../../../content/clients.en';
import styles from './AddClient.module.css';

const AddClient: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [form] = Form.useForm();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (values: Record<string, unknown>): void => {
    if (!user?.sub) return;
    const empty = createEmptyClient();
    const clientData: Omit<Client, 'id'> = {
      ...empty,
      firstName: String(values.firstName ?? ''),
      lastName: String(values.lastName ?? ''),
    };
    const created = createClient(user.sub, clientData);
    navigate(`/clients/${created.id}`);
  };

  return (
    <div className={styles.addClient}>
      <div className={styles.container}>
        <div className={styles.header}>
          <Link to="/clients" className={styles.backLink}>
            <ArrowLeftOutlined /> {clientCrmEn.actions.back}
          </Link>
          <h1 className={styles.title}>{clientsEn.addClient}</h1>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className={styles.form}
        >
          <div className={styles.section}>
            <div className={styles.sectionTitle}>{clientCrmEn.clientDetails}</div>
            <Form.Item
              name="firstName"
              label={clientCrmEn.name.firstName}
              rules={[{ required: true, message: 'First name is required' }]}
            >
              <Input placeholder="First name" />
            </Form.Item>
            <Form.Item
              name="lastName"
              label={clientCrmEn.name.lastName}
              rules={[{ required: true, message: 'Last name is required' }]}
            >
              <Input placeholder="Last name" />
            </Form.Item>
          </div>

          <div className={styles.actions}>
            <Button type="primary" htmlType="submit">
              {clientCrmEn.actions.save}
            </Button>
            <Button onClick={() => navigate('/clients')}>
              {clientCrmEn.actions.cancel}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddClient;
